import { Injectable } from '@angular/core';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { NavController } from '@ionic/angular';
// VENDORS
import { Observable, of } from 'rxjs';
import { map, catchError, filter } from 'rxjs/operators';
// SERVICES
import { VersionConfigService } from '@app/core/services/version-config';

@Injectable({
  providedIn: 'root',
})
export class UpdateVersionGuard {
  constructor(
    private _versionConfigService: VersionConfigService,
    private _navController: NavController,
  ) {}

  canActivate(
    _route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<any> {
    return this._versionConfigService
      .getAppVersionUpdateRequirementStatus()
      .pipe(
        filter((status) => status !== null),
        map((doesAppVersionNeedUpdate): doesAppVersionNeedUpdate is boolean => {
          if (!doesAppVersionNeedUpdate) {
            this._navController.navigateRoot(['app'], {
              animated: true,
              animationDirection: 'back',
            });
            return false;
          } else {
            return true;
          }
        }),
        catchError((_err) => {
          return of(false);
        }),
      );
  }
}
